'use strict';

angular.module('webAgro1App').factory('PluviometrosService', function($http) {
  return {
    list: function(params) {
      return $http.get(`${SERVER }/v1/pluviometros`, {
        params
      });
    }
  };
});
